import { httpTokenCommon } from "../../helper/http-common";

class ActivityLogService {
  addActivityLogsAPI(inputData) {
    return httpTokenCommon.post("user-activity/log", inputData);
  }
}
const activityLogService = new ActivityLogService();
export default activityLogService;
